import { clsx } from "@trydig/ui";
import styles from "./skeleton.module.css";

interface SkeletonProps {
	height: string;
	absolute?: boolean;
	className?: string;
}
export const Skeleton = ({ height, absolute, className }: SkeletonProps) => {
	return (
		<div
			className={clsx(styles.skeleton, className, "skeleton")}
			style={{
				animation: "skeleton-loading 1s linear infinite alternate",
				height,
				position: absolute ? "absolute" : "relative",
			}}
		/>
	);
};
